const env = window.__APP_ENV__ || {};
export default env;